import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ApplicantDetailsComponent} from '../../../shared/components/applicant-details/applicant-details.component';
import {AddressDetailsComponent} from '../../../shared/components/address-details/address-details.component';
import {LoginService} from '../../../shared/services/login.service';
import {Router} from '@angular/router';
import {FormControl, Validators} from '@angular/forms';
import {PlumberDetailsComponent} from '../../../shared/components/plumber-details/plumber-details.component';
import {PlumberDetails} from '../../../shared/data-objects/plumber-details';
import {Steps} from 'primeng/primeng';
import {IppaymentService} from '../../../shared/services/ippayment.service';
import {ApplicationFormBase} from '../../../shared/data-objects/application-form-base';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {ServiceBase} from '../../../shared/services/service-base';
import {ApplicationBase} from '../../../shared/data-objects/application-base';
import {WorkrequestViewmodelBase} from '../../../shared/viewmodels/workrequest-viewmodel-base';
import {Usr} from '../usr';
import {WorkrequestUsrComponent} from '../workrequest-usr/workrequest-usr.component';
import {UsrService} from '../usr.service';
import {OwnerDetailsComponent} from '../../../shared/components/owner-details/owner-details.component';
import {User} from '../../../shared/data-objects/user';
import {Meta} from '@angular/platform-browser';

const referenceNumberRE = /^[a-zA-Z0-9\-\/\.\:]+$/;

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-usr',
  templateUrl: 'usr.component.html',
  styleUrls: ['usr.component.css'],
  entryComponents: [ApplicantDetailsComponent, OwnerDetailsComponent,
  AddressDetailsComponent, WorkrequestUsrComponent, PlumberDetailsComponent],
  encapsulation: ViewEncapsulation.None
})

export class UsrComponent extends ApplicationFormBase<Usr> implements OnInit {
  isRequesting: boolean;

  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestUsrComponent;
  @ViewChild('PlumberDetailsComponent') plumberDetailsComponent: PlumberDetailsComponent;
  @ViewChild('OwnerDetailsComponent') owner: OwnerDetailsComponent;

  constructor(protected loginService: LoginService,
              private usrService: UsrService, protected ipPaymentService: IppaymentService, protected router: Router, private meta: Meta) {
    super(usrService, loginService, ipPaymentService, router);
    this.meta.updateTag({ name: 'description', content: 'Sewer (only) urgent repairs to existing internal plumbing (clearance of stoppages, replacement/repairs of defective plumbing within same location, etc).' });
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.setupTabs();
    }
  }

  setupTabs(): void {
    const me = this;

    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(this.usrService.applicationData.applicant);
    } else {
      // this.setApplicantDetailsForGuestUser(this.usrService.applicationData.applicant);
      this.setApplicantDetailsForNonBillLater(this.usrService.applicationData.applicant);
    }

    this.addMenuItem('Location details', me, 0, 'First Step');
    this.addMenuItem('Work request', me, 1, 'Second Step');
    this.addMenuItem('Plumber details', me, 2, 'Third Step');
    this.addMenuItem('Owner details', me, 3, 'Fourth Step');
    this.addMenuItem('Applicant details', me, 4, 'Fifth Step');
    this.addMenuItem('Review and submit', me, 5, 'Sixth Step');
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  get commitDisabled(): boolean {
    return (
      !this.usrService.agreedToTsAndCs ||
      this.applicant.invalid ||
      this.owner.invalid ||
      this.location.invalid ||
      this.workrequestComponent.invalid ||
      this.plumberDetailsComponent.invalid
    );
  }

  get ownerDetailsViewModel(): User {
    return this.usrService.applicationData.owner;
  }

  get plumberDetails(): PlumberDetails {
    return (<Usr>this.usrService.applicationData).plumberDetails;
  }

  get isBelowGroundPlumbingSelected(): boolean {
    return !this.isRecycledWaterZone;
  }

  get isDrinkingWaterSelected(): boolean {
    return false;
  }

  get isRecycledSelected(): boolean {
    return this.isRecycledWaterZone;
  }

  get drainerNameLabel(): string {
    return 'Plumber';
  }

  get isRecycledWaterZone(): boolean {
    return this.location.IsRecycledWaterZone;
  }

  get workRequestViewModel(): WorkrequestViewmodelBase {
    return this.usrService.workRequestViewModel;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.usrService.submitErrorMessage = '';

    if (this.activeIndex === 0) {
      this.navigateFromLocation(executeYes, executeNo);
    } else if (this.activeIndex === 1) {
      this.workrequestComponent.errorMessage = null;
      if (!this.workrequestComponent.invalid && this.workrequestComponent.displayErrorMessage().length > 0) {
        this.workrequestComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 2) {
      this.plumberDetailsComponent.errorMessage = null;
      if (this.plumberDetailsComponent.invalid && this.plumberDetailsComponent.displayErrorMessage().length > 0) {
        this.plumberDetailsComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 3) {
      if (this.owner.invalid && this.owner.displayErrorMessage().length > 0) {
        this.usrService.submitErrorMessage += this.owner.displayErrorMessage();
        executeNo();
        return;
      }
      executeYes();
    } else if (this.activeIndex === 4) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.usrService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }

      this.validTermsAndConditions(executeNo, executeYes);
    } else {
      executeYes();
    }
  }

  goNext(): void {
    if (this.activeIndex === 5) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  canGoPrevious(): boolean {
    if (this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  get srp(): ApplicationBase {
    return this.usrService.applicationData;
  }

  submitApplication(callback): void {

    let validData = true;
    this.usrService.submitErrorMessage = '';

    if (this.location.invalid) {
      this.usrService.submitErrorMessage += this.location.displayErrorMessage();
      validData = false;
    }

    this.workrequestComponent.errorMessage = null;
    if (!this.workrequestComponent.invalid && this.workrequestComponent.displayErrorMessage().length > 0) {
      this.usrService.submitErrorMessage += this.workrequestComponent.displayErrorMessage();
      validData = false;
    }

    this.plumberDetailsComponent.errorMessage = null;
    if (this.plumberDetailsComponent.invalid) {
      this.usrService.submitErrorMessage += this.plumberDetailsComponent.displayErrorMessage();
      validData = false;
    }

    if (this.owner.invalid) {
      this.usrService.submitErrorMessage += this.owner.displayErrorMessage();
      validData = false;
    }

    if (this.applicant.invalid) {
      this.usrService.submitErrorMessage += this.applicant.displayErrorMessage();
      validData = false;
    }

    if (!this.usrService.agreedToTsAndCs) {
      this.usrService.submitErrorMessage += 'Please select terms and conditions.';
      validData = false;
    }

    if (!validData) {
      return;
    }
    this.setApplicantData();
    this.usrService.applicationData.toUpperCase();
    this.usrService.applicationData.plumberDetails = this.plumberDetailsComponent.plumberDetails;
    this.usrService.applicationData.workrequestDetails = this.workrequestComponent.workRequestViewModel.workrequestDetails;
    this.usrService.applicationData.owner = this.owner.applicantDetails;
    this.usrService.applicationData.locationAddress = this.location.addressDetails.locationAddress;
    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.workrequestComponent.markValidationControlsAsUntouched();
    //this.plumberDetailsComponent.markValidationControlsAsUntouched();
    //this.owner.markValidationControlsAsUntouched();
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayPlumberDetails(): boolean {
    return this.activeIndex === 2;
  }

  get shouldDisplayOwner(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 4;
  }

  get shouldDisplayNextButton(): boolean {
    return this.activeIndex !== 5;
  }

  get shouldShowReviewAndSubmit(): boolean {
    return this.activeIndex === 5;
  }

  private doSubmit(callback): void {
    this.executeSubmit('usr', callback, 0, null, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/usr-form/usr/usr.component.ts